// Rejilla común de las tablas por años (nov-2026, petición de Raúl: en una
// misma pantalla todas las tablas de años deben ir ALINEADAS — mismo ancho de
// la columna de concepto y de cada año, empezando todas en el mismo sitio).
//
// Uso: <table className={TABLA_ANIOS}><ColsAnios n={años} />…</table>
// - `table-fixed` + <colgroup>: el navegador NO recalcula anchos por el
//   contenido, así que dos tablas con los mismos años quedan columna a
//   columna, aunque sus etiquetas o cifras midan distinto.
// - Una última <col> sin ancho absorbe el sobrante: la tabla ocupa todo el
//   ancho de su tarjeta, pero los años no se estiran (una tabla con 3 años y
//   otra con 5 comparten la posición de los 3 primeros). `.tabla-anios
//   tr::after` (index.css) rellena esa columna para que fondos y bordes de
//   fila lleguen al final.
// - En pantallas estrechas la tabla mide al menos la suma de columnas y el
//   contenedor `overflow-x-auto` hace scroll.
export const COL_CONCEPTO = 260;
export const COL_ANIO = 120;
// Años con importes completos en euros y céntimos ("-12.345.678,90 €")
export const COL_ANIO_EUR = 150;
// Ídem en letra monoespaciada (Resultados de proyección, Resumen, Flujos)
export const COL_ANIO_MONO = 160;

export const TABLA_ANIOS = "tabla-anios w-full table-fixed";

// `antes`: anchos de columnas propias delante de los años (p. ej. un checkbox
// o un código); `despues`: columnas propias detrás (tendencia, acciones…).
export function ColsAnios({ n, concepto = COL_CONCEPTO, anio = COL_ANIO, antes = [], despues = [] }) {
  return (
    <colgroup>
      {antes.map((w, i) => <col key={`a${i}`} style={{ width: w }} />)}
      <col style={{ width: concepto }} />
      {Array.from({ length: n }, (_, i) => <col key={i} style={{ width: anio }} />)}
      {despues.map((w, i) => <col key={`d${i}`} style={{ width: w }} />)}
      <col />
    </colgroup>
  );
}
